export const supportRequiredFieldLabel = (label: string) => `${label} *`;
